import React from 'react';
import './Modal.css';

const DeleteConfirmModal = ({ isOpen, cupl, onClose, onConfirm, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !loading && onClose()}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚠️ Confirmar Eliminación</h2>
        </div>

        <div className="modal-body">
          <p>¿Estás seguro de que deseas eliminar este CUPL?</p>
          {cupl && (
            <div className="cupl-preview">
              <div className="preview-item">
                <span className="label">CUPL:</span>
                <span className="value">{cupl.cupl_number}</span>
              </div>
              <div className="preview-item">
                <span className="label">Placa:</span>
                <span className="value">{cupl.plate}</span>
              </div>
              <div className="preview-item">
                <span className="label">Propietario:</span>
                <span className="value">{cupl.owner_name}</span>
              </div>
            </div>
          )}
          <p className="warning-text">⚠️ Esta acción no se puede deshacer</p>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-delete"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? '⏳ Eliminando...' : '🗑️ Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
